import axios from "axios";
import {getSelfToken} from '../../_helpers/auth/secureToken'
import {updateUserInfoApi} from '../_constants/api.constant'
export async function createAddress(postData,userId){
    const response=await axios.put(
       updateUserInfoApi.UPDATE+"?id="+userId,
       postData,
        {
            headers:{
                Authorization: 'Token '+getSelfToken(),
            },
        }
        ).then(function(response) {
        return response;
        }).catch(function (error) {
        // handle error
     

        console.log(error);
        console.log(error.response);
        return error.response;
        });
    return response;
}